import { render, staticRenderFns } from "./DialogChat.vue?vue&type=template&id=6b3edaf0&scoped=true"
import script from "./DialogChat.vue?vue&type=script&lang=js"
export * from "./DialogChat.vue?vue&type=script&lang=js"
import style0 from "./DialogChat.vue?vue&type=style&index=0&id=6b3edaf0&lang=scss"
import style1 from "./DialogChat.vue?vue&type=style&index=1&id=6b3edaf0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3edaf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3edaf0')) {
      api.createRecord('6b3edaf0', component.options)
    } else {
      api.reload('6b3edaf0', component.options)
    }
    module.hot.accept("./DialogChat.vue?vue&type=template&id=6b3edaf0&scoped=true", function () {
      api.rerender('6b3edaf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogChat.vue"
export default component.exports